import React, { FC } from "react";
import classNames from "classnames";
import { Fade } from "react-awesome-reveal";
import { BlockHeader } from "@app/components/common/block-header/BlockHeader";
import { IRichText, TextType } from "@app/models/storyblok/basic";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { Carousel } from "./components/carousel/Carousel";
import { CarouselCard } from "./components/carousel/components/card/types";

type Props = {
  title: IRichText<TextType>;
  cards: CarouselCard[];
};

export const CardsCarousel: FC<Props> = ({ title, cards }) => (
  <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
    <section className={classNames("mt-20", "lg:mt-25", "xl:mt-40")}>
      <BlockHeader
        richText={title}
        className={classNames(
          "mb-12 px-5 text-large text-primary-content",
          "lg:px-16",
          "xl:px-24 xl:text-xx-large",
          "xxl:mx-auto xxl:max-w-container-wide",
        )}
      />
      <Carousel {...{ cards }} />
    </section>
  </Fade>
);
